import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { VendorManagementEffects, vendorManagementFeature } from './store';

export function provideVendorManagementFeature(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(vendorManagementFeature),
    provideEffects(VendorManagementEffects),
  ]);
}
